import { IconButton } from '@material-ui/core';
import type { Theme } from '@material-ui/core/styles';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import ClearIcon from '@material-ui/icons/Clear';
import React from 'react';

import styles from './LiveVideoModal.module.css';

interface Props {
  hideModal: () => void;
  videoId: string;
}

interface LiveVideoType {
  hideModal: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    exitButton: {
      '&:hover': {
        backgroundColor: '#7e92c7',
      },
      width: theme.spacing(5),
      height: theme.spacing(5),
      backgroundColor: '#FFFFFF',
      marginBottom: '10px',
    },
    exitIcon: {
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
      color: 'white',
    },
  }),
);

const LiveVideo: React.FC<Props> = ({ hideModal, videoId }: Props) => {
  const classes = useStyles();
  return (
    <div className={styles.liveVideoModal}>
      <div className={styles.liveVideoBtnContainer}>
        <IconButton className={classes.exitButton} onClick={hideModal}>
          <ClearIcon className={classes.exitIcon} />
        </IconButton>
      </div>
      <div className={styles.liveVideo}>
        <iframe
          className={styles.liveVideoVideo}
          src={`https://www.youtube.com/embed/${videoId}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      </div>
    </div>
  );
};

export const LiveVideoModal =
  (videoId: string) =>
  ({ hideModal }: LiveVideoType) => {
    return <LiveVideo videoId={videoId} hideModal={hideModal} />;
  };
